<template>
	<ion-button
		v-if="copyIsSupported"
		size="small"
		fill="outline"
		@click="handleCopy"
	>
		<ion-icon slot="start" :icon="copyOutline" />
		{{ $t("common.copy") }}
	</ion-button>
</template>

<script setup lang="ts">
	import { IonButton, IonIcon } from "@ionic/vue";
	import { copyOutline } from "ionicons/icons";
	import { useClipboard } from "@vueuse/core";
	import type { InviteDTO } from "seedgreen-shared/dtos/InviteDTO";
	import { sendToast } from "@/utils/sendToast";
	import { useI18n } from "vue-i18n";

	interface Props {
		invite: Pick<InviteDTO, "userName" | "signupLink">;
	}

	const props = defineProps<Props>();
	const { t } = useI18n();
	const { copy, isSupported: copyIsSupported } = useClipboard();

	/**
	 * Copy the invite link to clipboard with a formatted message
	 */
	const handleCopy = async () => {
		const message = `You've been invited to join SeedGreen!

Username: ${props.invite.userName}
Sign up here: ${props.invite.signupLink}`;

		try {
			await copy(message);
			await sendToast(
				t("invite-modal.invite-link-copied"),
				2000,
				"success",
			);
		} catch (error) {
			console.error("Failed to copy link:", error);
			await sendToast(t("invite-modal.failed-to-copy"), 2000, "danger");
		}
	};
</script>
